import { createContext, Dispatch, SetStateAction } from "react";
import { ProfileType, UserTypeEnum } from "../Structures";

type ProfileContextType = {
  profile: ProfileType;
  setProfile: Dispatch<SetStateAction<ProfileType>>;
  setPersonalVerification: (value: boolean) => void;
  getProfile: () => void
};

const ProfileContext = createContext<ProfileContextType>({
  profile: {
    user_type: UserTypeEnum.USER,
    phoneNumber: "",
    first_name: "",
    last_name: "",
    fatherName: null,
    nationalCode: null,
    city: null,
    gender: null,
    birthDay: null,
    profile: null,
    personalVerification: false,
    coach: null,
    verified_by_coach: false,
    verified_by_responsible: false,
    document: {
      federationMembershipCard: null,
      insuranceCard: null,
    },
  },
  setProfile: () => {},
  setPersonalVerification: (value) => {},
  getProfile: () => {}
});

export default ProfileContext;
